import { useSelectedPrimaryImage } from '~/hooks/image/useSelectedImages';
import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import { FormattedMessage } from 'react-intl';
import { GetSessionError } from '~/backend/connector-api/connector-components';
import {
    TranslationCustomizationFile,
    UserCustomization,
} from '~/backend/types';
import ImageDataDisplay from '~/components/InputDataPreview/ImageDataDisplay';
import { PredictionModel } from '~/utils/transforms/predictionModelsDataTransforms';
import ModelSelection from './ImageTranslationModelSelection';

type ImageTranslationProps = {
    availableModels: PredictionModel[];
    modelCustomizations: UserCustomization<TranslationCustomizationFile>[];
    onSubmit: (
        model: PredictionModel,
        selectedCustomization?: string,
        numSamples?: number
    ) => void;
    isLoadingModels: boolean;
    isSubmitting?: boolean;
    showPseudonymization: boolean;
    supportsSampleCount: boolean;
    isLoadingSession?: boolean;
    error?: Error | GetSessionError | null;
};

export default function ImageTranslation({
    availableModels,
    modelCustomizations,
    onSubmit,
    isLoadingModels,
    isSubmitting,
    isLoadingSession,
    error,
    showPseudonymization,
    supportsSampleCount,
}: ImageTranslationProps) {
    const primaryImage = useSelectedPrimaryImage();
    return (
        <Box display="flex" flexDirection="column" gap={2}>
            <Box>
                <Typography id="modal-modal-title" variant="h6" component="h2">
                    <FormattedMessage id="runImageTranslation" />
                </Typography>
                <Typography variant="body2">
                    <FormattedMessage id="runImageTranslationDescription" />
                </Typography>
            </Box>
            <ImageDataDisplay
                image={primaryImage}
                isLoading={isLoadingSession}
                error={error}
            />
            <ModelSelection
                isLoadingModels={isLoadingModels}
                availableModels={availableModels}
                modelCustomizations={modelCustomizations}
                onSubmit={onSubmit}
                modality={primaryImage?.seriesMetadata.modality}
                showPseudonymization={showPseudonymization}
                supportsSampleCount={supportsSampleCount}
                disabled={isLoadingModels}
                isSubmitting={isSubmitting}
            />
        </Box>
    );
}
